module.exports = __webpack_public_path__ + "static/media/guidemainpage.06b8d0c4.jpg";